import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Blog"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 18H10.5V19.5H3V18ZM3 13.5H10.5V15H3V13.5ZM19.5 10.5H4.5C3.67157 10.5 3 9.82843 3 9V4.5C3 3.67157 3.67157 3 4.5 3H19.5C20.3284 3 21 3.67157 21 4.5V9C21 9.82843 20.3284 10.5 19.5 10.5ZM4.5 4.5V9H19.5V4.5H4.5ZM19.5 21H15C14.1716 21 13.5 20.3284 13.5 19.5V15C13.5 14.1716 14.1716 13.5 15 13.5H19.5C20.3284 13.5 21 14.1716 21 15V19.5C21 20.3284 20.3284 21 19.5 21ZM15 15V19.5H19.5V15H15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Blog.vue"]]);
